import { NeonLoadingRing } from "@/components/feedback/NeonLoadingRing";
import { getNativeDeviceProfile } from "@/utils/nativeDevice";

export function RouteGateFallback() {
  if (getNativeDeviceProfile().isNativeRuntime) {
    return (
      <div
        data-jp-route-fallback="native"
        className="flex min-h-screen items-center justify-center bg-jp-bg-page text-jp-fg-primary"
      >
        <div role="status" aria-live="polite" aria-atomic="true">
          <NeonLoadingRing />
          <span className="sr-only">Loading Journal Party</span>
        </div>
      </div>
    );
  }

  return (
    <div
      data-jp-route-fallback="dashboard-skeleton"
      className="min-h-screen bg-jp-bg-page text-jp-fg-primary"
    >
      <div className="mx-auto flex min-h-screen w-full max-w-5xl flex-col gap-5 px-4 py-5 sm:px-6">
        <div className="flex items-center justify-between">
          <div className="h-8 w-32 rounded-lg bg-jp-fg-primary/12" />
          <div className="h-9 w-9 rounded-full bg-jp-bg-card" />
        </div>
        <div className="relative min-h-[46vh] overflow-hidden rounded-[28px] border border-jp-line-edge bg-jp-bg-card shadow-[shadow:var(--jp-shadow-card)]">
          <div className="absolute inset-0 bg-gradient-to-br from-jp-accent-primary/20 via-transparent to-jp-accent-secondary/12" />
          <div className="relative flex h-full min-h-[46vh] flex-col justify-end p-6">
            <div className="mb-5 h-3 w-28 rounded-full bg-jp-accent-primary/70" />
            <div className="h-10 w-4/5 max-w-lg rounded-xl bg-jp-fg-primary/14" />
            <div className="mt-4 h-3 w-full max-w-xl rounded-full bg-jp-fg-secondary/20" />
            <div className="mt-2 h-3 w-2/3 max-w-md rounded-full bg-jp-fg-secondary/16" />
            <div className="mt-7 h-12 w-40 rounded-full bg-jp-accent-primary/75" />
          </div>
        </div>
        <div className="grid gap-3 sm:grid-cols-3">
          <div className="h-24 rounded-2xl border border-jp-line-edge bg-jp-bg-card" />
          <div className="h-24 rounded-2xl border border-jp-line-edge bg-jp-bg-card/90" />
          <div className="h-24 rounded-2xl border border-jp-line-edge bg-jp-bg-card/80" />
        </div>
      </div>
    </div>
  );
}

export default RouteGateFallback;
